import { ArchiveConfirmationModalProvider } from '@/components/ConfirmationModal';
import { useErrorInline } from '@/context/InlineErrorContext/InlineErrorContext';
import { BusinessDocumentDetail } from '@/context/services/business_document/type';
import { PaymentRequestApp } from '@/features/business_documents/Detail/components/PaymentRequestApp';
import { BusinessDocumentBodyContent } from '@/features/business_documents/Detail/components/Right/BusinessDocumentBodyContent';
import { HeaderButtons } from '@/features/business_documents/Detail/components/Right/HeaderButton';
import { useBusinessDocumentEditable } from '@/features/business_documents/Detail/components/Right/hooks/useBusinessDocumentDetail';
import { useBusinessDocumentButtonActions } from '@/features/business_documents/Detail/components/hooks/useBusinessDocumentButtonActions';
import { ViewContextProvider } from '@/features/invoices/components/Details/Components/Context/ViewEdit';
import { Header } from '@/features/invoices/components/Details/Components/Header';
import { useGetFlags } from '@/hooks/useFeatureFlag';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import { Notification } from './InlineNotification';
import styles from './Right.module.scss';

const cx = classnames.bind(styles);

export type WrapContentProps = {
  data: BusinessDocumentDetail;
};

export const WrapperRight: FC<WrapContentProps> = memo(({ data }) => {
  const { setError, ErrorContextHolder } = useErrorInline();
  const editable = useBusinessDocumentEditable(data);
  const flag = useGetFlags('RELATION_FEATURE');

  const flagBusinessDrawerHeader = useGetFlags(
    'BUSINESS_DOCUMENT_DRAWER_HEADER'
  );

  const { onArchiveClick, onRestoreArchiveClick, copyIdUrl } =
    useBusinessDocumentButtonActions(data, setError);

  return (
    <ViewContextProvider>
      <div className={cx(styles['container'])}>
        {!flagBusinessDrawerHeader && (
          <Header className={cx(styles['headerContainer'])}>
            <HeaderButtons
              onArchiveClick={onArchiveClick}
              copyText={copyIdUrl}
              onArchiveRestoreClick={onRestoreArchiveClick}
              hasInvoiceReports={!!data.invoice_reports?.length && flag}
            />
          </Header>
        )}
        <div className={cx(styles['contentContainer'])}>
          <div className={cx(styles['content'])}>
            {ErrorContextHolder}
            <Notification isArchived={!!data.archived} />
            <BusinessDocumentBodyContent isEditable={editable} data={data} />
            {flag && <PaymentRequestApp data={data} />}
          </div>
        </div>
      </div>
    </ViewContextProvider>
  );
});
WrapperRight.displayName = 'WrapperRight';

export const BusinessDocumentDetailRightView: FC<WrapContentProps> = memo(
  ({ data }) => {
    return (
      <ArchiveConfirmationModalProvider>
        <WrapperRight data={data} />
      </ArchiveConfirmationModalProvider>
    );
  }
);
BusinessDocumentDetailRightView.displayName = 'BusinessDocumentDetailRightView';
